import { AssetfiAssetType } from '@/types/asset-type';

export default function BalanceSvg({ width, height }: AssetfiAssetType) {
  return (
    <svg width={width} height={height} viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.5957 6.44713C17.1558 6.91739 19.0957 9.16038 19.0957 11.8564C19.0957 14.894 16.6333 17.3564 13.5957 17.3564C11.4584 17.3564 9.60577 16.1373 8.69541 14.3564M5.5957 5.35645L6.5957 4.85645V8.85645M12.0957 6.85645C12.0957 9.89401 9.63327 12.3564 6.5957 12.3564C3.55814 12.3564 1.0957 9.89401 1.0957 6.85645C1.0957 3.81888 3.55814 1.35645 6.5957 1.35645C9.63327 1.35645 12.0957 3.81888 12.0957 6.85645Z"
        stroke="#242424"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
